export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14362.dec5f62e.jpg";